const BASE_URL = process.env.REACT_APP_BASE_URL;
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;
const EIDAS_BASE_URL= process.env.REACT_APP_EIDAS_BASE_URL;
export const authorize = async (idpid, responseType, state, redirectUri) => {
    const url = `${BASE_URL}/auth/oauth/authorize?idpid=${idpid}&response_type=${responseType}&state=${state}&redirect_uri=${encodeURIComponent(redirectUri)}`;

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Failed to authorize');
    }

    const contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/json')) {
        return await response.json();
    } else {
        return await response.text();
    }
};

export const getToken = async (code) => {
    const url = `${BASE_URL}/auth/oauth/token?idpid=tx`;
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('code', code);
    params.append('redirect_uri', `${REDIRECT_URI}`);

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params
    });

    if (!response.ok) {
        throw new Error('Failed to obtain token');
    }

    const data = await response.json();
    sessionStorage.setItem("access_token", data.access_token)
    return data.access_token;
};



export const logout = async (token) => {
    const url = `${EIDAS_BASE_URL}?idpid=tx&redirect_uri=${REDIRECT_URI}`;
    window.location.href = url;
};